import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { baseUrl } from "../../config";

export const useAuthValidation = (setShouldShowPreOnboarding, setIsLoading, shouldValidate) => {
  const navigate = useNavigate();

  useEffect(() => {
    const validateAuth = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(`${baseUrl}auth_validate`, {
          withCredentials: true,
        });

        const token = res?.data?.data?.token;
        const refreshToken = res?.data?.data?.refreshToken;
        const userData = res?.data?.data?.user;

        if (!token) throw new Error("Missing token");

        const decoded = jwtDecode(token);
        const { user_status: status, onboard_status } = decoded;

        if (status !== "Active") throw new Error("Account is inactive");

        // store session
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("refreshToken", refreshToken);
        sessionStorage.setItem("user", JSON.stringify(userData));

        setShouldShowPreOnboarding(onboard_status === 2);

        const currentPath = window.location.pathname;
        const isRoot = currentPath === "/" || currentPath === "/login";
        const isInsideAdmin = currentPath.startsWith("/admin");
        console.log(isInsideAdmin)

        // ⭐ If user is already inside admin routes → DO NOTHING
        // refresh should NOT redirect
        if (isInsideAdmin) return;

        // ⭐ If root and onboarding incomplete → redirect properly
        if (isRoot && onboard_status !== 2) {
          const targetPath =
            onboard_status === 0 ? "/admin" : "/admin";

          navigate(targetPath, { replace: true });
          return;
        }

        // ⭐ If root and onboarded → go to admin dashboard
        if (isRoot && onboard_status === 2) {
          navigate("/admin", { replace: true });
          return;
        }

        // ⭐ Auto logout after 10 hours
        setTimeout(() => {
          sessionStorage.clear();
          // localStorage.clear();
          navigate("/login", { replace: true });
        }, 1000 * 60 * 60 * 10);
      } catch (err) {
        console.error("Auth Validate Failed:", err);

        sessionStorage.clear();

        if (!window.location.pathname.includes("/login")) {
          navigate("/login", { replace: true });
        }
      } finally {
        setIsLoading(false);
      }
    };
    if (shouldValidate) {
      validateAuth();
    }
  }, [navigate, setShouldShowPreOnboarding, setIsLoading, shouldValidate]);
};
